import axios from 'axios';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('profile', 'profiles');

const customActions = {
  async LOAD_profiles({ commit }) {
    const result = await axios.get('api/profiles');
    const { data } = result;
    commit('SET_profiles', data);
    return data;
  },
  async UPDATE_profile({ commit }, data) {
    const i = odata.parseId(data.id);
    await axios.put(`api/profiles/${i}`, data);
    commit('SET_profiles', data);
  },
};

export default { ...actions, ...customActions };
